import React from "react";
import Container from "@ui/container";
import ComplexText from "@ui/complex-text";

import {
    IconInfo,
    IconWarningTriangle,
    IconWarningCircle,
    IconTickSolid,
} from "@ui/icons";
import colors from "tailwindcss/colors";

const mbConfigs = [
    {
        messageType: "infoBox",
        bgCol: "bg-skin-light",
        textCol: "text-skin-base",
        iconImg: () => <IconInfo strokeWidth="1" className="w-4 h-4" />,
    },
    {
        messageType: "dangerBox",
        bgCol: "bg-red-50",
        textCol: "text-skin-error",
        iconImg: () => <IconWarningTriangle stroke="#DC2626" />,
    },
    {
        messageType: "warningBox",
        bgCol: "bg-skin-warning",
        iconImg: () => <IconWarningTriangle stroke="#D37600" />,
    },
    {
        messageType: "successBox",
        bgCol: "bg-[#EFF8EC]",
        textCol: "text-skin-text-base",
        iconImg: () => <IconTickSolid className="w-5 h-5 text-[#54BF30]" />,
    },
];
const MessageBox = ({ data }) => {
    return <MessageBoxContent data={data} />;
};

const fontSizes = {
    Default: "text-base",
    XSmall: "text-xs",
    Small: "text-sm",
    Large: "text-lg",
    XLarge: "text-xl",
};
const getFontCss = (fontSize) => {
    if (!fontSize) return "text-xs";
    return fontSizes[fontSize];
};

export const MessageBoxContent = ({ data }) => {
    if (data && data.messageType) {
        const conf = mbConfigs.find((m) => m.messageType === data.messageType);
        const dataFor =
            data.messageFor?.length > 0
                ? {
                      [`data-${data.messageType.toLowerCase()}-for`]:
                          data.messageFor,
                  }
                : null;

        if (conf) {
            return (
                <div
                    {...dataFor}
                    className={`flex items-center space-x-1 py-3 rounded-md pl-3 pr-5 ${
                        data.bgColour || conf.bgCol
                    } `}
                >
                    <div
                        className={`mr-2 ${data.textColour || conf.textCol} ${
                            data.imgContainerClass
                        }`}
                    >
                        {data.iconImg || conf.iconImg()}
                    </div>
                    <div
                        className={`${getFontCss(data.fontSize)} ${
                            data.textColour || conf.textCol
                        } ${data.textContainerClass}`}
                    >
                        {data.value && data.value.length > 0 && (
                            <>{data.value}</>
                        )}
                        {data.valueComplex && (
                            <ComplexText values={data.valueComplex} />
                        )}
                    </div>
                </div>
            );
        }
    }
    return null;
};

export default MessageBox;
